import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const reviewRowStyle = css`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(0.5)};
`;

// Applied to fields whose answer is long enough that a half-width column would just wrap it awkwardly.
export const reviewRowFullWidthStyle = css`
  grid-column: 1 / -1;
`;

// Long unbroken strings (file names, emails, IDs) wrap instead of widening the grid.
export const reviewLabelStyle = css`
  overflow-wrap: anywhere;
`;

export const reviewValueStyle = css`
  overflow-wrap: anywhere;
  white-space: pre-wrap;
`;

export const reviewImagesRowStyle = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${theme.spacing(2)};
`;

// Square preview for imageUpload thumbnails.
export const reviewImageStyle = css`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};
`;

// Rectangular preview matching the front/back card capture aspect ratio used while filling the form.
export const reviewCardImageStyle = css`
  width: 150px;
  height: 100px;
  object-fit: cover;
  border-radius: ${theme.borderRadius.medium};
  border: 1px solid ${theme.colors.neutral20};
`;
